/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/layout_grid'
export default icon
